import { Component, OnInit, HostListener, ElementRef } from '@angular/core';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { AddProductCartComponent } from 'src/app/elements/add-product-cart/add-product-cart.component';
import { MatDialog } from '@angular/material/dialog'
import { SectionService } from 'src/app/services/section.service';

@Component({
  selector: 'app-separate-bar-promo',
  templateUrl: './separate-bar-promo.component.html',
  styleUrls: ['./separate-bar-promo.component.scss'],
  animations: [

    // Background Font Animation
    trigger('scrollAnimationBackgroundFont',[
      state('show', style({
        opacity: .05,
        transform: 'translateX(0)'
      })),
      state('hide', style({
        opacity: 0,
        transform: 'translateX(100%)'
      })),
      transition('show => hide', animate('1000ms 1s ease')),
      transition('hide => show', animate('800ms 0s ease')),
    ]),

    // Title Animation
    trigger('scrollAnimationTitle',[
      state('show', style({
        opacity: 1,
        transform: 'translateY(0)'
      })),
      state('hide', style({
        opacity: 0,
        transform: 'translateY(350px)'
      })),
      transition('show => hide', animate('1000ms 0.5s ease')),
      transition('hide => show', animate('700ms 0.6s ease')),
    ]),

    // Price Animation
    trigger('scrollAnimationPrice',[
      state('show', style({
        opacity: 1,
        transform: 'translateY(0)'
      })),
      state('hide', style({
        opacity: 0,
        transform: 'translateY(400px)'
      })),
      transition('show => hide', animate('1000ms 0.4s ease')),
      transition('hide => show', animate('750ms 0.7s ease')),
    ]),
    
    // Button "Sumar al Carrito"
    trigger('scrollAnimationButtonOne',[
      state('show', style({
        opacity: 1,
        transform: 'translateY(0)'
      })),
      state('hide', style({
        opacity: 0,
        transform: 'translateY(450px)'
      })),
      transition('show => hide', animate('1000ms 0.3s ease')),
      transition('hide => show', animate('800ms 0.8s ease')),
    ]),

    // Button "Ver Coleccion"
    trigger('scrollAnimationButtonTwo',[
      state('show', style({
        opacity: 1,
        transform: 'translateY(0)'
      })),
      state('hide', style({
        opacity: 0,
        transform: 'translateY(450px)'
      })),
      transition('show => hide', animate('1000ms 0.2s ease')),
      transition('hide => show', animate('850ms 0.9s ease')),
    ]),

    // Image Animation
    trigger('scrollAnimationImage',[
      state('show', style({
        opacity: 1,
        transform: 'translateX(0)'
      })),
      state('hide', style({
        opacity: 0,
        transform: 'translateX(-100%)'
      })),
      transition('show => hide', animate('1000ms 0.0s ease')),
      transition('hide => show', animate('900ms 1.1s ease')),
    ])
  ]
})
export class SeparateBarPromoComponent implements OnInit {

  state:string = 'hide';
  infoView: any;

  constructor(
    protected sectionService: SectionService,
    public el: ElementRef, 
    public dialog: MatDialog
  ) { }

  ngOnInit() {
    this.loadInfo();
  }

  onClickCart() {
    this.dialog.open(AddProductCartComponent, {
      width: '400px',
      data: { product: this.infoView.product, quantity: 1 }
    });
  }

  @HostListener('window:scroll')
  checkScroll(){
    const componentPosition = this.el.nativeElement.offsetTop
    const scrollPosition = window.pageYOffset

    if (scrollPosition >= componentPosition - 900) {
      this.state = 'show'
    }  else {
      this.state = 'hide'
    }
  }

  loadInfo() {
    this.sectionService.fetchProductFeatureBox().toPromise().then(data => {
      if (data.success) {
        this.infoView = data.response.data;
      }
    });
  }

  getBackgroundColor() {
    if (this.infoView && this.infoView.background_color) {
      return this.infoView.background_color;
    }
    return '#172d77';
  }

  onClickLink() {
    window.location.href = this.infoView.button_extra_url;
  }
}
